import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Site from "@/pages/Site";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
